import { buildSchema,buildProperty, buildCollection,ExtraActionsParams } from "@camberi/firecms";
import { FileUploader } from "react-drag-drop-files";
import Papa from "papaparse";
import { v4 as uuidv4 } from 'uuid';
import { fetchSignInMethodsForEmail, sendPasswordResetEmail } from "firebase/auth";
import Config from "../utils/config";
import { collection, doc, setDoc } from "firebase/firestore";





export default class MasteryRewards {

    constructor() {

    }

    static BuildCollection (isadmin:boolean, issuperadmin:boolean, groupname:string) {
      return buildCollection({
        path: "masteryRewards",
        group:groupname,
        exportable:false,
        schema: MasteryRewards.schema(),
        name: "Mastery Rewards",
        permissions: ({entity,path,user,authController,context}) => { 
            return ({
                read: isadmin,
                create: isadmin,
                update: issuperadmin,
                delete: issuperadmin
            });
        },

    
      })
    }


    static schema () {
        return buildSchema({
            name: "Mastery Rewards",
            properties: {
              
              name: {
                title: "Name",
                dataType: "string"
              },
              masteryPoints: {
                title: "Mastery Points to unlock",
                dataType: "number"
              },
              position:{
                title: "Tier",
                dataType: "string",
                config: {
                  enumValues: {
                      tier1: "TIER 1",
                      tier2: "TIER 2",
                      tier3: "TIER 3",
                      tier4: "TIER 4",
                  }
                } 
              },
              zone:{
                title: "Zone",
                dataType: "string",
                config: {
                  enumValues: {
                      zone1: "ZONE 1",
                      zone2: "ZONE 2",
                      zone3: "ZONE 3",
                      middle: "MIDDLE",
                  }
                } 
              },
              rewardType: {
                title: "Reward Type",
                dataType: "string",
                config: {
                  enumValues: {
                      XP: "Skill points",
                      Xsolla: "Xsolla Item",
                      XsollaCurrency: "Xsolla Currency",
                      defaultdeck: "default deck",
                      artcard: "art card",
                      bits: "bits"
                  }
                }
              },
              rewardSKU: {
                title: "Reward SKU (if Xsolla) or ID (if firestore)",
                dataType: "string",
              },

              rewardAmount: {
                title: "Reward Amount",
                dataType: "number"
              },

             
                
            }
          });
    }


    
}